require([
    'jquery',
    'base/MbiHelper',
    'flickity',
    'base/MbiImageSize'
], function(
    $,
    _,
    Flickity,
    mbiImageSize
    ) {
    'use strict'

        var flkty = new Flickity( '.swiper', {
            cellSelector: '.slide',
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            arrowShape: {
                x0: 30,
                x1: 60, y1: 25,
                x2: 60, y2: 20,
                x3: 60
            }
        });

        setTimeout(function(){

        	mbiImageSize.init();

        },100)

    // }
});

define("root/Assets/Templates/Html/swiper/Js/swiper", function(){});

